import * as React from 'react';
import PropTypes from 'prop-types';

import { sortSizes } from '../utilities';

function SizePicker({
  options,
  colour,
  selected,
  setSize,
  variants,
  handedness,
}) {
  if (options.length <= 0) return null;

  const uniqueProductSizes = [];

  options.forEach((option) => {
    if (!uniqueProductSizes.includes(option)) {
      uniqueProductSizes.push(option);
    }
  });

  const sortedSizes = sortSizes(uniqueProductSizes);
  // sortedSizes now contains an array of only the above possibilities.
  // Then we take the rest of the size options here...
  let tempSizes = uniqueProductSizes.filter(
    (size) => !sortedSizes.includes(size)
  );

  // ...and sort them alphabetically
  tempSizes = tempSizes.sort((a, b) => a.localeCompare(b));

  // Finally we append them to the original sorted array
  const sizeOptions = [].concat(sortedSizes, tempSizes);

  return (
    <div>
      <div className="font-bold leading-6">Size</div>
      <div className="flex flex-wrap -mt-3">
        {sizeOptions.map((option) => {
          const disabled =
            typeof variants.find((v) => {
              return (
                v.size === option &&
                v.colour === colour &&
                v.handedness === handedness
              );
            }) === 'object'
              ? !variants.find((v) => {
                  return (
                    v.size === option &&
                    v.colour === colour &&
                    v.handedness === handedness
                  );
                }).availableForSale
              : true;
          return (
            <button
              key={option}
              type="button"
              disabled={disabled}
              onClick={() => setSize(option)}
              className={`${
                option === selected
                  ? 'border-primary bg-primary text-white'
                  : 'border-gray-300 disabled:border-gray-100 bg-white active:bg-gray-100 active:text-gray-500'
              } ${
                option !== selected && !disabled ? 'hover:text-gray-400' : ''
              } ${
                disabled ? 'bg-gray-200 border-gray-200 shadow-inner' : ''
              } inline-flex items-center justify-center flex-grow-0 flex-shrink-0 h-10 max-w-xs px-3 mr-4 mt-4 text-base leading-5 transition duration-150 ease-in-out bg-white border disabled:border min-w-10 focus:outline-none focus:shadow-outline-primary focus:border-primary-lighter disabled:opacity-50 disabled:cursor-not-allowed last:mr-0`}
            >
              <span className="inline-block whitespace-no-wrap">{option}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

SizePicker.propTypes = {
  setSize: PropTypes.func,
  options: PropTypes.any,
  selected: PropTypes.any,
  variants: PropTypes.array,
  colour: PropTypes.any,
  handedness: PropTypes.any,
};

export { SizePicker };
